import type { FormConfig } from './types'

export const deviceForm: FormConfig = {
  id: 'device',
  title: { de: 'Mehr erfahren', en: 'Learn more' },
  submitLabel: { de: 'Abschicken', en: 'Send' },
  successMessage: {
    de: 'Vielen Dank, Ihre Anfrage wurde erfolgreich versendet.',
    en: 'Thank you, your request has been sent successfully.',
  },
  fields: [
    {
      id: 'firstName',
      type: 'text',
      label: { de: 'Vorname', en: 'First name' },
      required: true,
    },
    {
      id: 'lastName',
      type: 'text',
      label: { de: 'Nachname', en: 'Last name' },
      required: true,
    },
    {
      id: 'company',
      type: 'text',
      label: { de: 'Firma', en: 'Company' },
      required: true,
    },
    {
      id: 'zip',
      type: 'text',
      label: { de: 'PLZ', en: 'Postal code' },
      required: true,
    },
    {
      id: 'email',
      type: 'email',
      label: { de: 'E-Mail-Adresse', en: 'E-Mail Address' },
      required: true,
    },
    {
      id: 'phone',
      type: 'text',
      label: { de: 'Telefonnummer', en: 'Phone' },
    },
    {
      id: 'interestBloomeaInfo',
      type: 'checkbox',
      label: {
        de: 'Ja, ich möchte mehr Informationen zu den Bloomea Geräten erhalten.',
        en: 'Yes, I would like more information about the Bloomea devices.',
      },
    },
  ],
  consentField: {
    id: 'agreeWithPersonalDataProcessing',
    type: 'checkbox',
    required: true,
    label: {
      de: 'Ich bin mit der Speicherung und Verarbeitung der hier angegebenen personenbezogenen Daten einverstanden. Die Daten werden allein zum Zwecke der Kontaktaufnahme durch Mitarbeiter der "MALU WILZ Beaute GmbH" auf Grundlage unserer Datenschutzerklärung erhoben.',
      en: 'I agree to the storage and processing of the personal data given here. The data is collected solely for the purpose of establishing contact by employees of "MALU WILZ Beaute GmbH" on the basis of our data protection declaration.',
    },
  },
}
